import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react'
import { noop } from 'lodash'

interface LayoutRenderTabsContextType {
  /** Currently registered function (reactive — use for conditional UI). */
  handleEdit: () => void
  /** Register or clear the shared function. */
  setEdit: (handleEdit: () => void) => void
}

const LayoutRenderTabsContext = createContext<LayoutRenderTabsContextType>({
  handleEdit: noop,
  setEdit: noop,
})

export const LayoutRenderTabsProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [handleEdit, setHandleEdit] = useState<() => void>(noop)

  // Wrap in a function updater so a callback is stored, not invoked as a state updater.
  const setEdit = useCallback((next: () => void) => {
    setHandleEdit(() => next)
  }, [])

  const value = useMemo(
    () => ({
      handleEdit,
      setEdit,
    }),
    [handleEdit, setEdit]
  )

  return (
    <LayoutRenderTabsContext.Provider value={value}>
      {children}
    </LayoutRenderTabsContext.Provider>
  )
}

export const useLayoutRenderTabsContext = () =>
  useContext(LayoutRenderTabsContext)
